





























import { computed, defineComponent, PropType, toRef } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { MessageAttachment } from "@scrile/api-provider/dist/api/MessagesProvider";
import useAttachmentFilesInfo from "@/hooks/useAttachmentFilesInfo";
import BaseDuration from "@/components/BaseDuration";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";

export type AttachmentsInfo = {
  type: string;
  icon: string;
  count: number;
  duration?: string;
  class?: string;
};

export default defineComponent({
  name: "AttachmentsInfo",
  components: { BaseDuration, BaseIcon, FormatMoney },
  props: {
    files: { type: Array as PropType<(ContentFile | MessageAttachment | FileData)[]>, required: true },
    isTextPost: { type: Boolean, default: false },
    price: { type: Number },
    subscriptionPrice: { type: Number },
    showPrice: { type: Boolean, default: true },
  },
  setup(props) {
    const {
      imageCount,
      videoCount,
      documentCount,
      audioCount,
      vrCount,
      totalVideoFilesDuration,
    } = useAttachmentFilesInfo(toRef(props, "files"));
    const attachmentsInfo = computed<AttachmentsInfo[]>(() => {
      const list = [];
      if (props.isTextPost) {
        list.push({
          type: "text",
          icon: "sci-text-post",
          count: 0,
        });
      }
      if (vrCount.value > 0) {
        list.push({
          type: "vr",
          icon: "sci-360",
          count: vrCount.value,
        });
      }
      if (imageCount.value > 0) {
        list.push({
          type: "image",
          icon: "sci-image-line",
          count: imageCount.value,
        });
      }
      if (videoCount.value > 0) {
        list.push({
          type: "video",
          icon: "sci-video-cam-empty-line",
          count: videoCount.value,
          duration: totalVideoFilesDuration.value,
        });
      }
      if (audioCount.value > 0) {
        list.push({
          type: "audio",
          icon: "sci-custom-microphone",
          count: audioCount.value,
        });
      }
      if (documentCount.value > 0) {
        list.push({
          type: "other",
          icon: "sci-file-empty-line",
          count: documentCount.value,
        });
      }
      return list;
    });

    return { attachmentsInfo };
  },
});
